/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Scope_Teams_DescriptionInputs */



/**
* | output |
* | --- |
* | "Pick at least one team. Whoever is in it now can see and run the agent; people who join later get access automatically." |
*
* @param {Agent_Builder_Scope_Teams_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_scope_teams_description = /** @type {((inputs?: Agent_Builder_Scope_Teams_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Scope_Teams_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie mindestens ein Team. Wer jetzt darin ist, sieht und startet den Agenten; wer später dazukommt, erhält den Zugriff automatisch.")
	return /** @type {LocalizedString} */ ("Pick at least one team. Whoever is in it now can see and run the agent; people who join later get access automatically.")
});